"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createDeferred() {
    var resolve;
    var reject;
    // tslint:disable-next-line:promise-must-complete
    var promise = new Promise(function (res, rej) {
        resolve = res;
        reject = rej;
    });
    return { promise: promise, resolve: resolve, reject: reject };
}
exports.createDeferred = createDeferred;
//# sourceMappingURL=deferred.js.map